import React from 'react';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Footer from './components/Footer';
// If using AntD v5 in your project root:
// import 'antd/dist/reset.css';

export default function App() {
  return (
    <>
      <Navbar />
      <Home />
      <Footer/>
    </>
  );
}
